import { route } from "../router/route";

export const consultingTabList = [
  { title: "1:1 컨설팅이란?", path: route.consulting },
  { title: "사전 상담 받기", path: route.consulting_prior },
  { title: "신청하기", path: route.consulting_apply },
  { title: "진행 중인 컨설팅", path: route.consulting_progress },
];
